import { DynamicAudienceSection } from '../constants';

export type SectionsState = Partial<Record<DynamicAudienceSection, boolean>>;

type Store = {
  getSnapshot: () => SectionsState;
  setState: (update: (prevState: SectionsState) => SectionsState) => void;
  subscribe: (listener: () => void) => () => void;
};

export const createStore = (initialState: SectionsState): Store => {
  let state: SectionsState = initialState;
  const listeners = new Set<() => void>();

  return {
    getSnapshot: () => state,
    setState: (update) => {
      const next = update(state);
      if (next !== state) {
        state = next;
        listeners.forEach((listener) => listener());
      }
    },
    subscribe: (listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
};
